/**
 * Первый день курса — день с минимальным dayNumber среди не-дней-отдыха.
 * dayNumber — сортировочный ключ (может быть 0), поэтому сравнение по id, не по номеру.
 */
export function getFirstCourseDay (days: Day[]): Day | undefined {
  return days
    .filter(d => !d.dayOfRest)
    .reduce<Day | undefined>((min, d) => (!min || d.dayNumber < min.dayNumber ? d : min), undefined)
}

export function isFirstCourseDay (day: Day, days: Day[]): boolean {
  const first = getFirstCourseDay(days)
  return Boolean(first && day.id === first.id)
}
